import { Controller, useWatch } from "react-hook-form";
import { classNames } from "primereact/utils";

import { erroreCampoObbligatorio, inputTopic } from "_constants";
import { TopicLite } from "interfaces";
import { useState, useEffect } from "react";
import { getTopicListLite } from "services";
import { AutoComplete } from "primereact/autocomplete";

export const SelectTopicForSource = ({
  control,
  setValue,
  isRequired = true,
}: any) => {
  const [topicList, setTopicList] = useState<TopicLite[] | null>(null);
  const [filteredItems, setFilteredItems] = useState<TopicLite[] | null>(null);

  const topicId = useWatch({
    control,
    name: "topicId",
  });

  useEffect(() => {
    getTopicListLite()
      .then((response) => {
        setTopicList(response.data);
        if (topicId && response.data) {
          const selectedTopic = response.data.find(
            (topic: any) => topic.id === topicId
          );
          if (selectedTopic) {
            setValue("topic", selectedTopic);
          }
        }
      })
      .catch((_) => {});
  }, [setValue, topicId]);

  const searchItems = (event: any) => {
    let query = event.query;
    let _filteredItems = [];

    if (topicList?.length) {
      for (let i = 0; i < topicList.length; i++) {
        let item = topicList[i];
        if (item.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
          _filteredItems.push(item);
        }
      }

      setFilteredItems(_filteredItems);
    }
  };

  return (
    <Controller
      name="topic"
      control={control}
      rules={isRequired ? { required: erroreCampoObbligatorio } : {}}
      render={({ field, fieldState: { error } }) => (
        <div className="flex-container column">
          <AutoComplete
            id={field.name}
            {...field}
            placeholder={`${inputTopic}${isRequired ? "*" : ""}`}
            forceSelection={true}
            value={field.value}
            suggestions={filteredItems ?? []}
            completeMethod={searchItems}
            virtualScrollerOptions={{
              itemSize: 38,
              scrollHeight: `${
                filteredItems?.length
                  ? filteredItems?.length > 4
                    ? 225
                    : filteredItems?.length * 60 -
                      (filteredItems?.length - 1) * 20
                  : 0
              }px`,
            }}
            field="name"
            dropdown
            className={`${classNames({
              "p-invalid": error,
            })} width-100`}
            disabled={!topicList?.length}
            onBlur={() => {
              if (topicList?.some((item) => item.id === field.value?.id)) {
                field.onChange(field.value);
              }
            }}
          />
          {error && (
            <small className="p-error margin-bottom-4">{error.message}</small>
          )}
        </div>
      )}
    />
  );
};
